import { render } from "./LinkStart.vue?vue&type=template&id=584b6e6c"
import script from "./LinkStart.vue?vue&type=script&lang=js"
export * from "./LinkStart.vue?vue&type=script&lang=js"

import exportComponent from "C:\\websites\\kroechkwis-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__